import { showModal } from 'modal.react.js';

import area from 'components/shared/GlobalModalArea/area';

import { MagicImportCompletedModal } from './MagicImportCompletedModal';
import { MagicImportProcessingModal } from './MagicImportProcessingModal';

class MagicImportModalManager {
  private currentModalPromise: Promise<void> | null = null;
  private currentModalControl: { success: (value: any) => void } | null = null;

  async showProcessingModal(): Promise<void> {
    await this.closeModal();

    return new Promise((resolve) => {
      this.currentModalPromise = showModal(
        area,
        <MagicImportProcessingModal
          onClose={() => {
            this.closeModal();
            resolve();
          }}
          onModalReady={(closeModal) => {
            this.currentModalControl = { success: closeModal };
          }}
        />,
      );
    });
  }

  async showCompletedModal(importId?: number): Promise<void> {
    await this.closeModal();

    return new Promise((resolve) => {
      this.currentModalPromise = showModal(
        area,
        <MagicImportCompletedModal
          importId={importId}
          onClose={() => {
            this.closeModal();
            resolve();
          }}
        />,
      );
    });
  }

  async closeModal(): Promise<void> {
    if (this.currentModalControl) {
      this.currentModalControl.success(null);
      this.currentModalControl = null;
      this.currentModalPromise = null;
      await new Promise((resolve) => setTimeout(resolve, 100));
    }
  }
}

export const magicImportModalManager = new MagicImportModalManager();
